import React from "react";
import filter from "../../../../assets/images/filter.svg";
import blueFilter from "../../../../assets/images/BlueFilterIcon.svg";

const MaterialsNameHeader = (
  options,
  frozenCoulmns,
  sortData,
  projectNameOnClick,
  selectedFields,
) => {
  let splittedCol = options?.split("_").join(" ");
  const isFrozen = frozenCoulmns?.includes(options);

  return (
    <div className={`flex-display ${isFrozen ? "font-bold frozen-width" : ""}`}>
      <>
        <img
          src={selectedFields?.[options]?.[0] ? blueFilter : filter}
          alt="Column Filter"
          onClick={(e) => projectNameOnClick(e, options)}
          className="columnFilterIcon"
        />
        <span className="columnFilterIcon">
          {splittedCol === "DSBP InitiativeID" && "DSBP Initiative ID"}
          {splittedCol === "DSBP Initiative Name" && "DSBP Initiative Name"}
          {splittedCol === "RTA ProjectID" && "RTA Project ID"}
          {splittedCol === "RTA Project Name" && "RTA Project Name"}
          {splittedCol === "PIMaterialNumber" && "PI Material Number"}
          {splittedCol === "PIMaterialDescription" && "PI Material Description"}
          {splittedCol === "PIMaterialID" && "PI Material ID"}
          {splittedCol === "PiFPCID" && "PI FPC ID"}
          {splittedCol === "PIFPCNumber" && "PI FPC Number"}
          {splittedCol === "FPCDescription" && "PI FPC Description"}
          {splittedCol === "POANumber" && "POA Number"}
          {splittedCol === "POADescription" && "POA Description"}
          {splittedCol === "BufferToWorkRatio" && "B:W"}
          {splittedCol === "BufferToWork" && "B|W"}
          {splittedCol === "POAReleaseDate" && "ETA (AWM)"}
          {splittedCol === "AWPrinterDate" && "AW Date (DSBP)"}
          {splittedCol === "AWMProjectID" && "AWM Project ID"}
          {splittedCol === "AWMProjectName" && "AWM Project Name"}
          {splittedCol === "Action" && "Artwork Status"}
          {splittedCol === "AWM GroupPMP" && "Group"}
          {splittedCol === "DesignFlag" && "Design"}
          {splittedCol === "CICFlag" && "CIC"}
          {splittedCol === "ApprovedCopyElements" && "Copy"}
          {splittedCol === "FAFlag" && "FA"}
          {splittedCol === "POAStatus" && "POA creation/update status"}
          {splittedCol === "TDState" && "TD State"}
          {splittedCol === "PMPState" && "PMP State"}
          {splittedCol === "CountryOfSales" && "Country of Sales"}
          {splittedCol === "FAAssemblyState" && "Assemble FA Status"}
          {splittedCol === "FAApproval" && "FA Approval (A/A/R)"}
          {splittedCol === "Estimated AW Printer" && "No Miss AW@Printer date"}
          {splittedCol === "POATOBVEStatus" && "Send POA to BVE Status"}
          {splittedCol === "POATOBVEEndDate" && "Send POA to BVE End Date"}
          {splittedCol === "DispatchFAToPrinterStatus" && "Color Sep. Status"}
          {splittedCol === "DispatchFAToPrinterEndDate" && "Color Sep. End Date"}
          {splittedCol === "FAAssemblyEndDate" && "Assemble FA End Date"}
          {splittedCol === "FAApprovalEndDate" && "Approve FA End Date"}
          {splittedCol === "ProjectID" && "Project ID"}
          {splittedCol === "CICApprovalStatus" && "CIC Approval Status"}
          {splittedCol === "Rework" && "Rework"}
          {splittedCol === "SupportingPMP" && "Supporting PMP"}
          {splittedCol === "CICNeededFlag" && "CIC Needed Flag"}
          {splittedCol === "AWM PMPStatusComment" && "PMP Status Comment"}

          {splittedCol !== "DSBP InitiativeID" &&
            splittedCol !== "DSBP Initiative Name" &&
            splittedCol !== "RTA ProjectID" &&
            splittedCol !== "RTA Project Name" &&
            splittedCol !== "PIMaterialNumber" &&
            splittedCol !== "PIMaterialDescription" &&
            splittedCol !== "PIMaterialID" &&
            splittedCol !== "PiFPCID" &&
            splittedCol !== "PIFPCNumber" &&
            splittedCol !== "FPCDescription" &&
            splittedCol !== "POANumber" &&
            splittedCol !== "POADescription" &&
            splittedCol !== "BufferToWorkRatio" &&
            splittedCol !== "BufferToWork" &&
            splittedCol !== "AWMProjectID" &&
            splittedCol !== "AWMProjectName" &&
            splittedCol !== "Action" &&
            splittedCol !== "POAReleaseDate" &&
            splittedCol !== "AWPrinterDate" &&
            splittedCol !== "AWM GroupPMP" &&
            splittedCol !== "DesignFlag" &&
            splittedCol !== "CICFlag" &&
            splittedCol !== "ApprovedCopyElements" &&
            splittedCol !== "FAFlag" &&
            splittedCol !== "POAStatus" &&
            splittedCol !== "TDState" &&
            splittedCol !== "PMPState" &&
            splittedCol !== "CountryOfSales" &&
            splittedCol !== "FAAssemblyState" &&
            splittedCol !== "FAApproval" &&
            splittedCol !== "Estimated AW Printer" &&
            splittedCol !== "POATOBVEStatus" &&
            splittedCol !== "POATOBVEEndDate" &&
            splittedCol !== "DispatchFAToPrinterStatus" &&
            splittedCol !== "DispatchFAToPrinterEndDate" &&
            splittedCol !== "FAAssemblyEndDate" &&
            splittedCol !== "FAApprovalEndDate" &&
            splittedCol !== "ProjectID" &&
            splittedCol !== "CICApprovalStatus" &&
            splittedCol !== "Rework" &&
            splittedCol !== "SupportingPMP" &&
            splittedCol !== "CICNeededFlag" &&
            splittedCol !== "AWM PMPStatusComment" &&
            splittedCol}
        </span>
      </>
    </div>
  );
};

export default MaterialsNameHeader;
